module.exports = __webpack_public_path__ + "img/split.34846680.png";